<template>
    <div>
        <div class="card mb-3" id="regInfo-list">
            <div class="card-header headline cash-desk">
                <h2 class="text-white d-inline">سال مالی</h2>
                <button class="btn btn-secondary float-left" @click="onCreateClicked">افزودن سال مالی</button>
            </div>
            <div class="card-body">
                <div class="row">

                    <div class="col-12 text-center" v-if="saleMali.length>0">
                        <div class="table-responsive">
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th class="text-center text-nowrap">نام</th>
                                    <th class="text-center text-nowrap">توضیحات</th>
                                    <th class="text-center text-nowrap">ابتدای سال</th>
                                    <th class="text-center text-nowrap">انتهای سال</th>
                                    <th class="text-center text-nowrap">انتخاب شده</th>
                                    <th class="text-center text-nowrap">بسته شده</th>
                                    <th class="text-center text-nowrap">عملیات</th>
                                </tr>
                                </thead>
                                <tbody v-if="saleMali !== undefined">
                                <tr v-for="(item,index) in saleMali">
                                    <!--<td class="product-remove-button"><a class="text-danger" @click="onRemoveProductClicked(index)"><i class="fa fa-close"></i></a></td>-->
                                    <td class="text-center clickable" @click="onCardClicked(index)">{{item.name}}</td>
                                    <td class="text-center">{{item.description}}</td>
                                    <td class="text-center">{{item.fstartDate}}</td>
                                    <td class="text-center">{{item.fendDate}}</td>
                                    <td class="text-center clickable" @click="selectSalemali(index)">
                                        <i v-if="item.selected" class="fa fa-check-square-o"></i>
                                        <i v-else class="fa fa-square-o"></i>
                                    </td>
                                    <td class="text-center">
                                        <i v-if="item.closed" class="fa fa-calendar-check-o"></i>
                                        <i v-else class="fa fa-circle-o"></i>
                                    </td>
                                    <td class="text-center clickable">
                                        <button class="btn btn-success" v-if="!item.closed" @click="sendToSalemali(index)" title="انتقال حسابهای بدون سال به این سال مالی">انتقال حسابهای بدون سال به این سال مالی</button>
                                        <button class="btn btn-success" v-if="item.closed" @click="openSalemali(index)" title="بازگشایی سال مالی و ویرایش سندها"><i class="fa fa-folder-open-o"></i></button>
                                        <button class="btn btn-success" @click="sortSalemaliAccountNumber(index)" title="مرتب کردن شماره سندهای حسابداری">
                                            <i class="fa fa-sort-numeric-asc"></i>
                                        </button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12 text-center" v-else>
                        <span>سال مالی ثبت نشده است</span>
                    </div>
                </div>
            </div>
        </div>

        <!---------------------- MODALS ------------------------------>
        <div class="modal fade" id="saleMali-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white">ثبت سال مالی</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="saleMaliModel.name">
                                </div>
                            </div>
                            <div class="col-lg-6   mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">توضیحات</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="saleMaliModel.description">
                                </div>
                            </div>
                            <div class="col-lg-6   mb-2">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend" @click="toggleStartDatePicker">
                                        <div class="input-group-text"><span>ابتدای سال مالی</span></div>
                                    </div>
                                    <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                                 ref="datePickerStart" style="flex: 1">
                                        <slot>
                                            <input v-model="startDatePersian" class="form-control date-input" readonly="true"
                                                   @click="toggleStartDatePicker">
                                        </slot>
                                    </date-picker>
                                </div>
                            </div>

                            <div class="col-lg-6   mb-2">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend" @click="toggleEndDatePicker">
                                        <div class="input-group-text"><span>انتهای سال مالی</span></div>
                                    </div>
                                    <date-picker type="date" :auto-submit="true" :disable="startDatePersian" format="jYYYY-jMM-jDD"
                                                 @input="onEndDatePicked"
                                                 ref="datePickerEnd" style="flex: 1;">
                                        <slot>
                                            <input v-model="endDatePersian" class="form-control date-input" readonly="true"
                                                   @click="toggleEndDatePicker">
                                        </slot>
                                    </date-picker>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-danger mr-2" @click="deleteItem()">حذف</button>
                        <button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>


<script>
    import * as $ from 'jquery';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import VsSelect from "../../_framework/VsSelect";
    import Moment from "moment-jalali";
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import EventBus from '../../_framework/event-bus.js';


    export default {
        name: 'saleMali',
        components: {VsSelect, DatePicker},
        data() {
            return {
                regInfos: [],
                queryParams: {
                    pageSize: 8,
                    pageIndex: 0,
                    name: "",
                    types: 1
                },
                preselectedregInfo: {},
                preselectedAccountType: {},
                saleMali: [],
                saleMaliModel: {
                    name: "",
                    description: "",
                    selected: false,
                    closed: false,
                    startDate: null,
                    endDate: null,
                },
                params: {
                    mode: 'create'
                },
                searchString: "",

                transactions: [],
                listView: true,
                transactionsQuery: {
                    pageSize: 8,
                    pageIndex: 0,
                    code: 0
                },
                dataCount: 0,
                transactionCount: 0,

                autoload: false,
                isSending: false,
                fromDate: "",
                fromDateJ: "",
                toDate: "",
                toDateJ: "",
                startDatePersian: "",
                endDatePersian: "",

            }
        },
        mounted() {
            this.getsalemali();

        },
        methods: {
            getsalemali() {
                new BaseService('account', '/Getsalemali').getList().then(response => {
                    if (response.data !== null && response.data !== "") {
                        this.saleMali = response.data.value;
                    }
                    if (this.saleMali.length > 0) {
                        for (let item of this.saleMali) {
                            item.fstartDate = Moment(item.startDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                            item.fendDate = Moment(item.endDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                        }
                    }
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });
            },
            onCreateClicked() {
                this.saleMaliModel.id = undefined;
                $("#saleMali-modal").modal("show");
            },
            onCardClicked(index) {
                this.saleMaliModel = JSON.parse(JSON.stringify(this.saleMali[index]));
                console.log(this.saleMaliModel)
                this.startDatePersian = Moment(this.saleMaliModel.startDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                this.endDatePersian = Moment(this.saleMaliModel.endDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                $("#saleMali-modal").modal("show");
            },
            onModalOk() {
                if (this.saleMaliModel.startDate === null) {
                    Utils.handleErrorWithNotification("لطفا ابتدای را انتخاب کنید", this.$noty);
                } else if (this.saleMaliModel.endDate === null) {
                    Utils.handleErrorWithNotification("لطفا انتهای را انتخاب کنید", this.$noty);
                } else if (this.saleMaliModel.name === null) {
                    Utils.handleErrorWithNotification("لطفا نام سال را وارد کنید", this.$noty);
                } else {
                    if (!this.isSending) {
                        this.isSending = true;
                        if (this.saleMaliModel.id === undefined || this.saleMaliModel.id === null || this.saleMaliModel.id === 0) {
                            new BaseService('account/CreateSaleMali').create(this.saleMaliModel).then(response => {
                                this.$noty.success("اطلاعات با موفقیت ویرایش شد.");
                                this.isSending = false;
                                this.getsalemali();
                                $("#saleMali-modal").modal("hide");
                            }).catch(error => {
                                this.isSending = false;
                                Utils.handleErrorWithNotification(error.data.message, this.$noty);
                            });
                        } else {

                            new BaseService('account/UpdateSaleMali').update(this.saleMaliModel).then(response => {
                                this.$noty.success("اطلاعات با موفقیت ویرایش شد.");
                                this.isSending = false;
                                this.getsalemali();
                                $("#saleMali-modal").modal("hide");
                            }).catch(error => {
                                this.isSending = false;
                                Utils.handleErrorWithNotification(error.data.message, this.$noty);
                            });
                        }
                    }

                }
            },
            selectSalemali(index) {
                this.saleMaliModel = JSON.parse(JSON.stringify(this.saleMali[index]));
                if (this.saleMaliModel.closed) {
                    this.$noty.error("این سال مالی بسته شده و قابل انتخاب نیست.");
                } else {
                    if (this.saleMaliModel.selected) {
                        this.$noty.error("این سال مالی هم اکنون فعال است.");
                    } else {
                        if (confirm("آیا میخواهید این سال مالی را انتخاب کنید؟")) {
                            new BaseService('account', `/selectsalemali/${this.saleMaliModel.id}`).getList().then(response => {
                                if (response.data !== null && response.data !== "") {
                                    this.saleMali = response.data.value;
                                }
                                if (this.saleMali.length > 0) {
                                    for (let item of this.saleMali) {
                                        item.fstartDate = Moment(item.startDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                                        item.fendDate = Moment(item.endDate, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
                                        if (item.selected) {
                                            EventBus.$emit('saleMaliChange', item.name);
                                            localStorage.setItem("salemali_start", item.startDate);
                                            localStorage.setItem("salemali_end", item.endDate);

                                        }
                                    }
                                }

                            }).catch(error => {
                                console.log(error)
                                Utils.handleErrorWithNotification(error.data.message, this.$noty);
                            });
                        }
                    }
                }
            },
            sendToSalemali(index) {
                this.saleMaliModel = JSON.parse(JSON.stringify(this.saleMali[index]));

                if (confirm("آیا میخواهید کلیه سندهای بدون سال مالی را به این سال مالی انتقال بدهید؟")) {
                    new BaseService('account', `/sendToSalemali/${this.saleMaliModel.id}`).getList().then(response => {
                        this.$noty.success("حسابها با موفقیت انتقال یافت");
                    }).catch(error => {
                        console.log(error);
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            openSalemali(index) {
                this.saleMaliModel = JSON.parse(JSON.stringify(this.saleMali[index]));

                if (confirm("آیا میخواهید سال مالی را بازگشایی کنید و سندها را ویرایش کنید؟")) {
                    new BaseService('account', `/openSalemali/${this.saleMaliModel.id}`).getList().then(response => {
                        this.$noty.success("سال مالی با موفقیت بازگشایی شد");
                    }).catch(error => {
                        console.log(error);
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            sortSalemaliAccountNumber(index) {
                this.saleMaliModel = JSON.parse(JSON.stringify(this.saleMali[index]));

                if (confirm("آیا میخواهید شماره سند حسابداری همه حساب ها را از 1 مرتب کنید؟")) {
                    new BaseService('account', `/SortSalemaliAccountNumber/${this.saleMaliModel.id}`).getList().then(response => {
                        this.$noty.success("شماره ها با موفقیت مرتب شد");
                    }).catch(error => {
                        console.log(error);
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEndDatePicker() {
                this.$refs.datePickerEnd.togglePicker();
            },
            onStartDatePicked(val) {
                this.saleMaliModel.startDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.startDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            onEndDatePicked(val) {
                this.saleMaliModel.endDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.endDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            deleteItem() {

            },

        },

    }
</script>